import React, { useState, useEffect } from 'react';
import Modal from '@material-ui/core/Modal';
import useStyles from './index.style';
import { ReactComponent as CloseX } from '../../../../assets/svg/close-x_blue.svg';

const MuiModal = ({
  modalStatus,
  handleClose,
  title,
  children,
  customClass,
  showCloseButton = false,
  parentCustomClass,
}) => {
  const modalClasses = useStyles();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(modalStatus);
  }, [modalStatus]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby={title}
      aria-describedby={title}
      className={modalClasses.modal}
      style={parentCustomClass}>
      <div style={customClass} className={modalClasses.innerContainer}>
        {showCloseButton && (
          <div className={modalClasses.headerCloseButton}>
            <CloseX onClick={handleClose} tabIndex={0} aria-label="Close modal" />
          </div>
        )}
        <div>{children}</div>
      </div>
    </Modal>
  );
};

export default MuiModal;
